import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    '& > *': {
      margin: theme.spacing(2)
    },
  },
  section: {
    marginTop: theme.spacing(3),
  },
  schedule_root: {
      width: '100%',
  },
  schedule_details: {
      display: 'block',
  },
  schedule_header: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
  },
  schedule_subHeader: {
      marginBottom: theme.spacing(1),
  },
  schedule_sectionContainer: {
      width: '100%',
      // minHeight: 150,
      border: `solid #eee 1px`,
      borderRadius: '3px',
      padding: '20px',
      marginBottom: theme.spacing(3),
  },
  tab_root: {
    borderBottom: `1px solid #eee`,
    marginBottom: theme.spacing(4),
  },
  accordionLessonSchedule: {
    minHeight: "500px",
    width: '100%',
    border: `solid #eee 1px`,
    borderRadius: '3px',
    padding: '20px',
    marginBottom: theme.spacing(3),

  },
  table_headerText: {
      fontSize: '18px',
  },
  table_row: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  table_expandCaret: {
      width: '5%',
  },
  text: {
    fontSize: '16px',
    marginLeft: '5%',
  },
  labelIcon: {
    marginRight: theme.spacing(1),
    display: 'flex',
    padding: '0px',
  },
  dfb: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    maxHeight: 550,
    padding: '10px',
  },
  dfe: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 0,
    padding: 0
  },
  userSearchResultsTable: {
  width: '100%',
  cursor: 'pointer',
  paddingLeft: 0,
  paddingRight: 0,
  display: 'table'
  },
  userSearchSelectedRow: {
    backgroundColor: '#3B4B95',
    '& > *': { color: 'white' }
  },
  userActionButtons: {
    padding: '10px',
    marginTop: theme.spacing(2),
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  verticalBtn: {
    margin: 'auto',
    width: '18rem',
    marginTop: theme.spacing(1),
  },
  infoIcon: {
    verticalAlign: 'text-top',
    marginLeft: theme.spacing(.5),
  },
  errMsg: {
      fontSize: '1rem',
      color: 'red',
      marginTop: theme.spacing(2)
  },
  successMsg: {
      width: '15rem',
      color: 'green'
  },
  pFormControl: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '100%',
  },
  progress_sectionContainer: {
    width: '100%',
    border: `solid #eee 1px`,
    borderRadius: '3px',
    marginBottom: theme.spacing(3),
  },
  lessonTitle_text: {
    fontSize: '14px',
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'initial',
  },
  progress_text: {
    fontSize: '14px',
    padding: theme.spacing(1, 0),
  },
  progress_div: {
    lineHeight: '14px',
    fontSize: '14px',
    paddingTop: theme.spacing(2.5),
  },
  progress_table: {
    margin: theme.spacing(-2),
  },
  progress_button: {
    textTransform: 'lowercase',
    textDecoration: 'underline',
    fontSize: '14px',
    margin: 0,
    padding: 0,
    justifyContent: 'start',
    fontFamily: 'Roboto',
  },
  buttons: {
    width: '38px',
    height: '26px',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 1.43,
    letterSpacing: '0.2px',
    color: theme.palette.text.secondary,
    '&.Mui-selected': {
      color: theme.palette.info.dark,
      backgroundColor: theme.palette.background.paper,
      '&:not(:first-child)': {
        borderLeft: `1px solid ${theme.palette.divider}`,
      },
    },
  },
  groupedNoBorders: {
    '& .MuiToggleButtonGroup-grouped': {
      border: 'none',
      padding: theme.spacing(0),
      '&:not(:first-child)': {
        borderLeft: `1px solid ${theme.palette.divider}`,
      },
    },
  },
});
